import { STATIC_ASSETS_URL } from "common/context/constants"
import "../style.scss"

const NotificationsByMonthTitle = ({ title }: $TSMigrationFixMe) => {
  return (
    <div className='notifications-list-by-month-title d-flex'>
      <img
        className='mr-1'
        src={`${STATIC_ASSETS_URL}/Imagenes/Ilustraciones/Bicolor.svg`}
        alt='Bicolor.svg'
      />
      <div className='my-auto'>{title}</div>
    </div>
  )
}

export default NotificationsByMonthTitle
